import React from 'react';
import '../../assets/styles/StepTwo.css';
import learnImg from '../../assets/images/ARISE WEBSITE_how-08.webp';
import practiceImg from '../../assets/images/ARISE WEBSITE_how-09.webp';
import certifyImg from '../../assets/images/ARISE WEBSITE_how-10.png';
import recognisedImg from '../../assets/images/ARISE WEBSITE_how-11.webp';

const StepTwo = () => {
  return (
    <div className="step-two-wrapper font-regular">
      <div className="step-two-header font-bold">
        <h2>Step 2: Complete the ESB Course</h2>
        
         <div className="esb-help-separator"></div>
        <p>
          <span className="step-accent">Learn, Practice, Certify:</span> Gain the skills and
          credibility to take your idea forward.
        </p>
      </div>

      <div className="step-two-grid">
        {/* Learn */}
        <div className="step-card">
          <img src={learnImg} alt="Learn" />
          <h3><span className="highlight">Learn:</span></h3>
          <p>
            Complete the ESB Course to gain knowledge in entrepreneurship and small business ecosystems
          </p>
        </div>

        {/* Practice */}
        <div className="step-card">
          <img src={practiceImg} alt="Practice" />
          <h3><span className="highlight">Practice:</span></h3>
          <p>
            Take the practice test to familiarise yourself with the course format.
          </p>
        </div>

        {/* Certify */}
        {/* <div className="step-card">
          <img src={certifyImg} alt="Certify" />
          <h3><span className="highlight">Certify:</span></h3>
          <p>
            Appear for the certification exam at your designated center, aiming for a minimum score of 70% (which is
            required to register as part of a team for ARISE FOR YOU™)
          </p>
        </div> */}

        {/* Get Recognised */}
        <div className="step-card">
          <img src={recognisedImg} alt="Get Recognised" />
          <h3><span className="highlight">Get Recognised:</span></h3>
          <p>
            Receive your ESB Course, Completion Certificate, an acknowledge that proves your readiness to
            take the next step.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
